import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/ds";

/**
 * One row of a Panel card — the same 52px row the Menú sheet uses, which is
 * what the spec asks for ("filas de 52px, con el mismo estilo de fila que el
 * sheet"). The trailing slot holds a count in mono or a status pill before the
 * chevron, per the mockup's `NUM()` and `OK`.
 */
export default function PanelRow({ icon, label, mono, accent, to, onClick, count, pill, last, testId }) {
  const style = {
    minHeight: mono ? 60 : 52, display: "flex", alignItems: "center", gap: 14,
    padding: "0 4px", width: "100%", textAlign: "left",
    border: "none", background: "transparent", cursor: "pointer",
    font: "600 16px var(--font-display)", letterSpacing: "-.01em",
    color: accent ? "var(--hive-ink)" : "var(--text-body)", textDecoration: "none",
    borderBottom: last ? "none" : "1px solid var(--linen)",
  };
  const body = (
    <>
      <Icon
        name={icon} size={22}
        style={{ color: accent ? "var(--hive-ink)" : "var(--smoke)", flex: "none" }}
      />
      {/* A handle rides under its app's name in mono, the way the mockup sets
          it: the two lines are a name and an address, not one sentence. */}
      <span style={{ display: "grid", gap: 1, minWidth: 0, flex: 1 }}>
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {label}
        </span>
        {mono && (
          <span
            style={{
              font: "500 12px var(--font-mono)", color: "var(--smoke)",
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
            }}
          >
            {mono}
          </span>
        )}
      </span>
      {count > 0 && (
        <span style={{ marginLeft: "auto", font: "500 13px var(--font-mono)", color: "var(--smoke)" }}>
          {count}
        </span>
      )}
      {pill && (
        <span
          style={{
            marginLeft: "auto", display: "inline-flex", alignItems: "center",
            height: 24, padding: "0 10px", borderRadius: 8,
            font: "700 11px var(--font-display)", letterSpacing: ".08em",
            textTransform: "uppercase",
            background: "var(--success-tint)", color: "var(--success)",
          }}
        >
          {pill}
        </span>
      )}
      <Icon
        name="chevron-right" size={18}
        style={{ color: "var(--sand-deep)", flex: "none", marginLeft: count > 0 || pill ? 0 : "auto" }}
      />
    </>
  );
  if (to) {
    // `fromPanel` is what makes the section wear "‹ Panel"; see panelSections.
    return <Link to={to} state={{ fromPanel: true }} style={style} data-testid={testId}>{body}</Link>;
  }
  return <button type="button" onClick={onClick} style={style} data-testid={testId}>{body}</button>;
}
